const AUTH_KEY = "token";
const CURRENT_USR = "currentUser";


class StorageService {
    static clearStorage(key = "") {
        if (key) {
            localStorage.removeItem(key);
        } else {
            const exceptKey = "color-theme";
            const valueToKeep = localStorage.getItem(exceptKey);

            // Clear the local storage
            localStorage.clear();

            // Restore the value of the exceptKey
            if (valueToKeep !== null) {
                localStorage.setItem(exceptKey, valueToKeep);
            }
        }
    }

    static setItem(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error(`Error setting item in localStorage: ${error}`);
        }
    }

    static getItem(key) {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            console.error(`Error getting item from localStorage: ${error}`);
            return null;
        }
    }

    static setToken(token) {
        this.setItem(AUTH_KEY, token);
    }

    static getToken() {
        return this.getItem(AUTH_KEY);
    }
    static setCurrentUser(data) {
        try {
            const jsonData = JSON.stringify(data);
            this.setItem(CURRENT_USR, jsonData);
        } catch (error) {
            console.error(`Error setting current user in localStorage: ${error}`);
        }
    }

    static getCurrentUser() {
        try {
            const jsonData = this.getItem(CURRENT_USR);
            return jsonData ? JSON.parse(jsonData) : null;
        } catch (error) {
            console.error(`Error getting current user from localStorage: ${error}`);
            return null;
        }
    }

}

export default StorageService;

// Example usage:
// StorageService.setToken('your-token');
// const token = StorageService.getToken();
// StorageService.clearStorage();
